<script setup lang="ts">
</script>

<template>
  <section class="relative h-[90vh] min-h-155 w-full overflow-hidden">
    <!-- Background image -->
    <img
      src="/images/bg-header.jpg"
      alt="Allenamento endurance"
      class="absolute inset-0 h-full w-full object-cover
           brightness-75 blur-[2px] scale-105"
    >

    <!-- Overlay (leggibilità testo) -->
    <div
      class="absolute inset-0 bg-linear-to-r
           from-white/90 via-white/70 to-white/30
           dark:from-slate-950/90 dark:via-slate-950/70 dark:to-slate-950/30"
    />

    <!-- Contenuto -->
    <UContainer class="relative z-10 h-full">
      <div class="grid h-full items-center gap-10 lg:grid-cols-2">
        <!-- TESTO -->
        <div class="max-w-xl">
          <UBadge
            class="mb-4 border border-slate-200 bg-white/80 text-slate-700
                 dark:border-slate-800 dark:bg-slate-950/70 dark:text-slate-200"
          >
            Metodo PureJoule · Coaching endurance
          </UBadge>

          <h1 class="text-4xl font-bold tracking-tight text-slate-900 dark:text-white md:text-5xl">
            Allenati meglio.
            <br>
            <span class="text-primary-600 dark:text-primary-400">
              Ogni joule conta.
            </span>
          </h1>

          <p class="mt-4 text-lg text-slate-700 dark:text-slate-300">
            Coaching personalizzato per atleti amatori che vogliono migliorare
            <strong>senza sprecare energia</strong>.
            Metodo, progressione sostenibile e supporto continuo.
          </p>

          <div class="mt-6 flex flex-col gap-3 sm:flex-row">
            <UButton to="#manifesto" size="lg" color="primary">
              Scopri il metodo
            </UButton>
          </div>
        </div>
      </div>
    </UContainer>
  </section>
</template>

<style scoped>
</style>
